module.exports = __webpack_public_path__ + "img/fig18.a322eb5b.jpg";